import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import axios from "axios";
import _ from "underscore";
import LoaderPanel from "../components/LoaderPanel";
import ConfirmDropdown from "../components/ConfirmDropdown";
import TitlePage from "../components/TitlePage";
import withLoadSave from "../components/LoadSave";
import MenuNavbar from "../components/MenuNavbar";
import { EDTableSection, EDTable, EDTableRow } from "../components/EDDOM";

class IntegrationsShopify extends Component {
  constructor(props) {
    super(props);

    props.setLoadedCB(this._loadCB);
  }

  _loadCB = () => {
    if (!this._initial && this.props.data.length === 0) {
      this.props.history.replace('/integrations/shopify/connect?auto=true');
    }
    this._initial = true;
  }

  createClicked = async () => {
    this.props.history.push('/integrations/shopify/connect');
  }

  deleteConfirmClicked = async name => {
    await axios.delete('/api/shopifyshops/' + name);
    await this.props.reload();
  }

  render() {
    let minWidth = '600px';
    let maxWidth = '1024px';

    return (
      <MenuNavbar {...this.props}>
        <TitlePage title="Shopify Integrations" button={
          <Button bsStyle="primary" onClick={this.createClicked}>Connect New Shop</Button>
        }/>
        <LoaderPanel isLoading={this.props.isLoading}>
          <EDTableSection className="contact drop-blue">
          {
            this.props.data.length ?
              <EDTable className="growing-margin-left" minWidth={minWidth} maxWidth={maxWidth}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th></th>
                  </tr>
                </thead>
                {
                  _.map(this.props.data, (t, index) =>
                      <EDTableRow key={t.id} index={index}>
                        <td>
                          <ul className="list-inline first-tr">
                            <li>
                              <h4 style={{whiteSpace: 'nowrap'}}>
                                <Link to={t.complete?('/integrations/shopify/edit?id=' + t.name):('/integrations/shopify/connect?name=' + t.name)}>
                                  {t.displayname?t.displayname:t.name}
                                  {!t.complete && ' (not connected)'}
                                </Link>
                              </h4>
                            </li>
                          </ul>
                        </td>
                        <td style={{minWidth:'112px'}} className="last-cell">
                          <ConfirmDropdown
                            id={t.id + '-split'}
                            text="Actions"
                            menu="Disconnect"
                            extra={true}
                            title="Disconnect Confirmation"
                            prompt={`Are you sure you wish to disconnect '${t.name}'?`}
                            onConfirm={this.deleteConfirmClicked.bind(this, t.name)}
                          >
                          </ConfirmDropdown>
                        </td>
                      </EDTableRow>
                  )
                }
              </EDTable>
              :
              <div className="text-center space-top-sm">
                <h4>You don&apos;t have any connected shops.</h4>
              </div>
          }
          </EDTableSection>
        </LoaderPanel>
      </MenuNavbar>
    );
  }
}

export default withLoadSave({
  extend: IntegrationsShopify,
  initial: [],
  get: async () => _.sortBy((await axios.get('/api/shopifyshops')).data, t => t.name.toLowerCase()),
});



// WEBPACK FOOTER //
// ./src/containers/IntegrationsShopify.js